export enum RoomsViews {
  BY_CATEGORY = 0,
  BY_STATUS = 1,
  BY_SHARED_WORKSPACE = 2,
  BY_CLASSIFICATION = 3,
  BY_SPONSOR = 4,
  BY_PRODUCT = 5,
  BY_PROGRAM = 6,
  BY_COUNTRY = 7,
  BY_ROOM_TYPE = 9,
  BY_SERVICE_OFFERING = 11,
  BY_RELATION_TYPE = 12,
}
